import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import fp from 'fingerprintjs2';
import Services from './services';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';

class KulsokliensContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES
      formNev: '',
      formEszkozazonosito: '',
      formHelyszin: '',
      formHelyszinOptions : []
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.listKliens();
    }
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  listKliens = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listKliens((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getKliens = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getKliens(id, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          formNev: this.nullToString(res[0].nev),
          formEszkozazonosito: this.nullToString(res[0].eszkozazonosito),
          formHelyszin: this.nullToString(res[0].helyszinid),
          formHelyszinOptions: res[0].init.helyszin
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'LOAD',
      formNev: '',
      formEszkozazonosito: '',
      formHelyszin: '',
      formHelyszinOptions: [],
      modalForm: true
    }, () => {
      this.initForm();
    });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getKliens(cell);
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  initForm = () => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initForm((err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',
          formHelyszinOptions: res[0].helyszin,
          formHelyszin: res[0].helyszin.length === 1 ? res[0].helyszin[0].id : ''
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  deleteKliens = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteKliens(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listKliens();
        this.props.globals.addSuccess('Kliens törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  getEszkozazonosito = () => {
    var options = {excludes: {colorDepth: true, pixelRatio: true, screenResolution: true, availableScreenResolution: true, webgl: true, fonts:true, canvas: true, adBlock: true, enumerateDevices: true}}
    fp.get(options, (components) => {
      var values = components.map(function (component) { return component.value })
      var murmur = fp.x64hash128(values.join(''), 31)
      // console.log(components);
      this.setState({
        formEszkozazonosito: murmur
      })
    })
  }

  submitForm = () => {
    const {
      currentId,
      formNev,
      formEszkozazonosito,
      formHelyszin,
      formType
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.eszkozazonosito = this.emptyOrNull(formEszkozazonosito);
      submitObj.helyszinid = this.emptyOrNull(formHelyszin);

      Services.addKliens(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Kliens felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listKliens();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.eszkozazonosito = this.emptyOrNull(formEszkozazonosito);
      submitObj.helyszinid = this.emptyOrNull(formHelyszin);

      Services.editKliens(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Kliens módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listKliens();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új kliens létrehozása';
      case 'MOD':
        return 'Kliens módosítása';
      default:
        return '';
    }
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'helyszin',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Kliens név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'eszkozazonosito',
        text: 'Eszköz azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS'], true),
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

renderForm = () => {
  const {
    formNev,
    formEszkozazonosito,
    formHelyszin,
    formType
  } = this.state;

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
            <RFField
              label={'Név: *'}
              name="formNev"
              id="formNev"
              maxLength="32"
              type="text"
              value={formNev}
              onChange={this.handleInputChange}
              required
              autocomplete="off"
            />
        </div>
        <div className="col-md-12">
            <RFField
              label={'Eszköz azonosító: *'}
              name="formEszkozazonosito"
              id="formEszkozazonosito"
              type="text"
              maxLength="32"
              value={formEszkozazonosito}
              onChange={this.handleInputChange}
              required
              autocomplete="off"
            />
          <Button block color="info" type="button" style={{ marginBottom: 10 }} onClick={this.getEszkozazonosito}>Azonosító lekérdezése</Button>
        </div>
        <div className="col-md-12">
          <RFField
            type="select"
            name="formHelyszin"
            id="formHelyszin"
            label="Helyszín: *"
            errorMessage="Kötelező mező!"
            required
            value={formHelyszin}
            onChange={this.handleInputChange}
            autocomplete="off"
            defaultSelect={<option value="">Válassz helyszint...</option>}
            selectOptions={this.renderHelyszinOptions()}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

renderHelyszinOptions = () => {
  return this.state.formHelyszinOptions.map((helyszin) => {
    return <option value={helyszin.id}>{helyszin.nev}</option>
  });
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12" style={this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS'], true) ? {marginTop: 0} : {marginTop: 22}}>
          {this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új kliens'}
            </Button>
          )}
          <br />
          {this.state.hash}
        </div>
        <div className="col-md-12">
          {{
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Vigyél fel új tételt!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { this.listKliens(); }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="sm">
        <RFForm
          onSubmit={this.submitForm}
          modalInsert
          title={this.renderFormTitle()}
          tagProps={{ isOpen: this.state.modalForm, toggle: this.toggleFormModal , backdrop: 'static', size: 'sm' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                type='submit'
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {/* <ModalHeader>{this.renderFormTitle()}</ModalHeader>
          <ModalBody> */}
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => {}}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
          {/* </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              loading={this.state.saveButtonLoading}
            >
              {'Mentés'}
            </ProgressButton>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
          </ModalFooter> */}
        </RFForm>
      </Modal>
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteKliens()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
}

KulsokliensContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default KulsokliensContent;
